import React from 'react';
import PropTypes from 'prop-types';
import RadioBase from './RadioBase';

/*
  <Radio
    options=[
      { display: 'somme text', value: 'somevalue'}
    ]
    value: 'somevalue'
  />
*/

class Radio extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override RadioBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Radio> */
    className: PropTypes.string,
    /** Options list for the radio group */
    options: PropTypes.array.isRequired,
    /** Value of `input` element */
    value: PropTypes.string,
    /** Text used for input label */
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]),
    /** If `true`, the label is displayed as required. */
    required: PropTypes.any,
    /** Callback fired when value is changed */
    onChange: PropTypes.func,
  };

  static defaultProps = {
    styleType: 'default',
  };

  getStyles = type => {
    switch (type) {
      default:
        return {
          labelAsterisk: {
            color: 'red',
          },
        };
    }
  };

  render() {
    const { styleType, options = [], ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <RadioBase styles={styles} options={options} {...otherProps} />;
  }
}

export default Radio;
